export default "__VITE_ASSET__CIikHY$3__"